import ManuallyPushLeadsModal from 'routes/LeadList/LeadListView/LeadListActions/ManuallyPushLeadsModal/ManuallyPushLeadsModal';

export default ManuallyPushLeadsModal;
